<template>
  <v-card>
    <v-card-text>
      <strong>Payment Methods</strong><br>
      <v-container fluid grid-list-sm>
        <v-layout row wrap>
          <payment-method v-for="paymentMethod in paymentMethods"
                          :key="paymentMethod.id"
                          :payment-method="paymentMethod"
                          @delete="deletePaymentMethod"
                          />
          <add-card @edit="editPaymentMethod" method="edit" :value="defaultMethod">
            Add Payment Method
          </add-card>
        </v-layout>
      </v-container>
    </v-card-text>
    <payment-method-form v-model="showEditDialog"
                         :payment-method="selectedPaymentMethod"
                         @save="savePaymentMethod"
                         @cancel="showEditDialog = false"
                         />
  </v-card>
</template>

<script>
import api from '@/api/gungho'
import Events from '@/api/events'
import PaymentMethod from './payment-method'
import PaymentMethodForm from './payment-method-form'
import AddCard from './add-card'

export default {
  components: {
    'payment-method': PaymentMethod,
    'payment-method-form': PaymentMethodForm,
    'add-card': AddCard
  },

  data () {
    return {
      showEditDialog: false,
      paymentMethods: [],
      selectedPaymentMethod: {},
      defaultMethod: {
        method_type: 'CreditCard',
        credit_card: {
          name: '',
          number: '',
          expiration: '',
          cvv: '',
          store: true,
          first_name: '',
          last_name: ''
        }
      }
    }
  },

  beforeMount () {
    this.loadPaymentMethods()
  },

  methods: {
    loadPaymentMethods () {
      api.paymentMethods().then(data => {
        this.paymentMethods = data.payment_methods
      }).catch(error => {
        console.log(error)
      })
    },

    editPaymentMethod (pm) {
      this.selectedPaymentMethod = pm
      this.showEditDialog = true
    },

    savePaymentMethod (pm) {
      console.log('Create Payment Method')
      api.createPaymentMethod(pm).then(data => {
        this.loadPaymentMethods()
        this.showEditDialog = false
        Events.$emit('toast', 'Created Payment Method')
      }).catch(error => {
        console.log(error)
      })
    },

    deletePaymentMethod (id) {
      this.$confirm(`Delete this Payment Method?`).then(confirmed => {
        if (!confirmed) return
        api.deletePaymentMethod(id).then(data => {
          this.loadPaymentMethods()
          Events.$emit('toast', 'Deleted Payment Method')
        }).catch(error => {
          console.log(error)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// payment-methods.vue?3df04771